/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { DASHBOARD_STAT_FRAGMENT } from '@/graphql'

export const GET_DASHBOARD_STATS = gql`
  query DashboardStats(
    $filters: DashboardFilter!
    $order: DashboardOrdering
    $pagination: OffsetLimitPaginationFilter
  ) {
    dashboardStats(filters: $filters, order: $order, pagination: $pagination) {
      totalCount
      results {
        ...DashboardStat
      }
    }
  }
  ${DASHBOARD_STAT_FRAGMENT}
`
